// Convert a decrypted LEGACY payload (wat_portable_version 1) into the CURRENT
// portable shape ({ format: "wat.portable", version: 1, turns: [...] }) that the
// backend /api/wat/import and turnsFromPortable already understand.
//
// Legacy turns place the visible envelope fields (answer, proactions, etc.)
// directly on each turn rather than inside a nested `envelope` object.

import { WatError } from "./watCrypto";

export function legacyToPortable(obj) {
  if (
    !obj ||
    Number(obj.wat_portable_version) !== 1 ||
    !Array.isArray(obj.turns) ||
    !obj.turns.length
  ) {
    throw new WatError("This file doesn't contain a WAT conversation.");
  }

  const turns = obj.turns.map((t, i) => {
    // Legacy: fields are flat on the turn. Be tolerant if a nested envelope exists.
    const env = t.envelope && typeof t.envelope === "object" ? t.envelope : t;
    return {
      seq: i + 1,
      user_input: t.user_input || "",
      deeper: !!t.deeper,
      level: t.level || 1,
      evidence_refs: Array.isArray(t.evidence_refs) ? t.evidence_refs : [],
      envelope: {
        answer: env.answer || "",
        advances_depth: !!env.advances_depth,
        depth_available: !!env.depth_available,
        depth_topic: env.depth_topic || "",
        proactions: Array.isArray(env.proactions) ? env.proactions : [],
        belief_change: env.belief_change || null,
        continuations: Array.isArray(env.continuations) ? env.continuations : [],
        deeper_alternatives: Array.isArray(env.deeper_alternatives) ? env.deeper_alternatives : [],
        invalidates_depth: env.invalidates_depth || 0,
        structured_blocks: Array.isArray(env.structured_blocks) ? env.structured_blocks : [],
      },
    };
  });

  return {
    format: "wat.portable",
    version: 1,
    exported_at: new Date().toISOString(),
    nav: obj.nav && typeof obj.nav === "object" ? obj.nav : {},
    turns,
  };
}
